// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1es4-","footer":"ReportModalFilter_footer__11D0p"};